export const vocabData = [
  {
    word: "accommodate",
    meaning: "수용하다, 적응하다",
    example: "The hotel can accommodate up to 500 guests.",
  },
  {
    word: "delegate",
    meaning: "위임하다, 대표",
    example: "The manager delegates tasks to team members.",
  },
  {
    word: "implement",
    meaning: "시행하다, 실행하다",
    example: "We will implement the new policy next month.",
  },
  {
    word: "facilitate",
    meaning: "촉진하다, 용이하게 하다",
    example:
      "The new software will facilitate communication between departments.",
  },
  {
    word: "anticipate",
    meaning: "예상하다, 기대하다",
    example: "We anticipate strong growth in the next quarter.",
  },
  {
    word: "comply",
    meaning: "준수하다, 따르다",
    example: "All employees must comply with safety regulations.",
  },
  {
    word: "enhance",
    meaning: "향상시키다, 증진하다",
    example: "Regular exercise enhances your overall health.",
  },
  {
    word: "allocate",
    meaning: "할당하다, 배분하다",
    example: "The budget will allocate funds for new projects.",
  },
  {
    word: "optimize",
    meaning: "최적화하다",
    example: "We need to optimize our production process.",
  },
  {
    word: "coordinate",
    meaning: "조정하다, 협력하다",
    example: "The team leader coordinates all project activities.",
  },
  {
    word: "release",
    meaning: "출시하다, 방출하다, 해제하다",
    example: "The company will release the new product next week.",
  },
  {
    word: "recruitment",
    meaning: "채용, 모집",
    example: "The HR department is handling the recruitment of new employees.",
  },
  {
    word: "domestic",
    meaning: "국내의, 가정의",
    example: "The company focuses mainly on domestic markets.",
  },
];
